var validate = require('./actions/validate');

var responseUtils = (function() {

    var _isValidAnswer = function(response, field, dispatch) {
        if(field.type !== 'text' && response.length === 0) {
            dispatch(validate.setResponseValidationError({message: "An answer is required in order to proceed."}));
            return false;
        } else if (field.hasOwnProperty('maxResponses') && response.length > field.maxResponses) {
            dispatch(validate.setResponseValidationError({message: "A maximum of " + field.maxResponses + " choices can be selected."}));
            return false;
        } else {
            dispatch(validate.clearResponseValidationError());
            return true;
        }
    };

    return {
        isValidAnswer: _isValidAnswer
    };

})();

module.exports = responseUtils;



// WEBPACK FOOTER //
// ./src/common/modules/responses/utils.js